const state = {
  produtosSelecionados: [],
  qtdeProdutosSelecionados: 0,
  resetProdutosSelecionados: 0
}

const getters = {
  getProdutosSelecionados(state){
    return state.produtosSelecionados;
  },

  getQtdeProdutosSelecionados(state){
    return state.qtdeProdutosSelecionados;
  },

  getResetProdutosSelecionados(state){
    return state.resetProdutosSelecionados;
  }
}

const mutations = {
  SET_PRODUTOS_SELECIONADOS(state, valor){
    state.produtosSelecionados = valor;
  },

  SET_QTDE_PRODUTOS_SELECIONADOS(state, valor){
    state.qtdeProdutosSelecionados = valor;
  },

  SET_RESET_PRODUTOS_SELECIONADOS(state){
    state.resetProdutosSelecionados++;
  }
}

export default { namespaced: true, state, mutations, getters }
